export const POSE_INDEX = {
    idle: 0, studying: 1, thinking: 2, break: 3,
    drinking: 4, sleepy: 5, celebrate: 6, exercise: 7,
};
//# sourceMappingURL=types.js.map